/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmAvailabilityDetailsRequest
 */
export interface ConfirmAvailabilityDetailsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmAvailabilityDetailsRequest
     */
    available: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ConfirmAvailabilityDetailsRequest
     */
    nextAvailabilityDate?: Date;
}

/**
 * Check if a given object implements the ConfirmAvailabilityDetailsRequest interface.
 */
export function instanceOfConfirmAvailabilityDetailsRequest(value: object): value is ConfirmAvailabilityDetailsRequest {
    if (!('available' in value) || value['available'] === undefined) return false;
    return true;
}

export function ConfirmAvailabilityDetailsRequestFromJSON(json: any): ConfirmAvailabilityDetailsRequest {
    return ConfirmAvailabilityDetailsRequestFromJSONTyped(json, false);
}

export function ConfirmAvailabilityDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmAvailabilityDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'],
        'nextAvailabilityDate': json['nextAvailabilityDate'] == null ? undefined : (new Date(json['nextAvailabilityDate'])),
    };
}

export function ConfirmAvailabilityDetailsRequestToJSON(value?: ConfirmAvailabilityDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'available': value['available'],
        'nextAvailabilityDate': value['nextAvailabilityDate'] == null ? undefined : ((value['nextAvailabilityDate']).toISOString().substring(0,10)),
    };
}

